export default function HomeActive({ width = 22, height = 23, className, style }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 22 23"
            fill="none"
            className={className}
            style={style}
            aria-hidden="true"
        >
            <path
                d="M0 9.17316C0 8.16546 0.469541 7.2153 1.27001 6.60318L9.03472 0.665459C10.1948 -0.221624 11.8052 -0.221625 12.9653 0.665459L20.73 6.60317C21.5305 7.2153 22 8.16546 22 9.17316V20.2567C22 21.4717 21.015 22.4567 19.8 22.4567H16.28C15.065 22.4567 14.08 21.4717 14.08 20.2567V15.3455C14.08 14.738 13.5875 14.2455 12.98 14.2455H9.02C8.41249 14.2455 7.92 14.738 7.92 15.3455V20.2567C7.92 21.4717 6.93503 22.4567 5.72 22.4567H2.2C0.984974 22.4567 0 21.4717 0 20.2567V9.17316Z"
                fill="#EAEAEA"
            />
        </svg>
    );
}
